import { useCallback } from 'react'

import { BuilderPage } from '@makyoapp/makyo-common'

import { Accordion } from '@/components/Accordion/Accordion'

import { ActionAccordion } from './Accordions'

interface PageSettingActionProps {
  page: BuilderPage
  pageIdx: number
  search: string
}

export const PageSettingAction = ({ page, pageIdx, search }: PageSettingActionProps) => {
  const getFilteredAccordionItems = useCallback(() => {
    if (!search.trim()) {
      return {
        showActionSettings: true,
      }
    }

    const searchLower = search.toLowerCase()

    return {
      showActionSettings: 'actions'.includes(searchLower) || 'on screen load'.includes(searchLower),
    }
  }, [search])

  const filteredItems = getFilteredAccordionItems()

  return (
    <>
      {filteredItems.showActionSettings && (
        <Accordion openMultiple={false} initialActiveItems={['action-settings']}>
          <ActionAccordion page={page} pageIdx={pageIdx} />
        </Accordion>
      )}
    </>
  )
}
